import { Form, FormGroup, RadioGroup, Select } from '../form';

export default ({
  htmlFile,
  htmlFiles,
  id,
  linkType,
  messages,
  onHtmlFileChange,
  onLinkTypeChange
}) => (
  <div className="zip-handler">
    <Form
      initialValues={{htmlFile, linkType}}
    >
      {({ formState }) => (
        <FormGroup label={messages.uploaderLinkTarget}>
          <RadioGroup
            field="linkType"
            onChange={onLinkTypeChange}
            options={[{
              id: `${id}-link-direct`,
              label: messages.editorBlockFileLinkDirect,
              value: 'direct'
            }, {
              id: `${id}-link-html`,
              label: messages.editorBlockFileLinkHtml,
              value: 'html'
            }]}
          />
          <div className="select">
            <Select
              disabled={formState.values.linkType !== 'html'}
              field={'htmlFile'}
              id={`${id}-zip-select`}
              onChange={onHtmlFileChange}
              options={htmlFiles.map(htmlFile => ({
                label: htmlFile,
                value: htmlFile
              }))}
            />
          </div>
        </FormGroup>
      )}
    </Form>

    <style jsx>{`
      .zip-handler {
        margin-top: 10px;
      }
      .select {
        margin-top: 5px;
      }
    `}</style>
  </div>
);
